import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart8: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChart8"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M12 16.5V7.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M7.5 16.5V12.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M16.5 16.5V10.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChart8;
